import { render, staticRenderFns } from "./fccSistema.vue?vue&type=template&id=b3275f4e"
import script from "./fccSistema.vue?vue&type=script&lang=js"
export * from "./fccSistema.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports